import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonProvider } from '../../providers/common/common';

@Component({
  selector: 'scanner',
  templateUrl: 'scanner.html'
})
export class ScannerComponent {
  @Input() formats = "'QR_CODE','EAN_13','CODE_39','CODE_128'";
  @Output() returnText = new EventEmitter<string>();
  @ViewChild('scanner') scannerElment;
  barcode_text:string;
  availableDevices: MediaDeviceInfo[];
  selectedDevice: MediaDeviceInfo;
  hasCameras:boolean = false;
  hasPermission: boolean;
  is_available:boolean = true;
  os_version:string;
  disp_caution:boolean = false;

  constructor(
    public comProv: CommonProvider
  ) {
    this.os_version = this.comProv.getOsVersion();
    if (!this.comProv.isApp()) {
      if (this.comProv.isIos()) {
        if (Number(this.os_version) < 11) {
          this.is_available = false;
        }
      }
    }

    setTimeout(() => {
      this.disp_caution = true;
    }, 3000)
  }

  ngOnInit () {
    this.scannerElment.camerasFound.subscribe((devices: MediaDeviceInfo[]) => {
      this.hasCameras = true;
      this.availableDevices = devices;
      this.setDevice();
    });

    this.scannerElment.permissionResponse.subscribe((answer: boolean) => {
      this.hasPermission = answer;
    });
  }

  setDevice() {
    let camera_no = 0;
    if (this.availableDevices.length > 1) {
      for (let i=0; i<this.availableDevices.length; i++) {
        if (this.availableDevices[i]['label'].indexOf('back') != -1 || this.availableDevices[i]['label'].indexOf('背面') != -1) {
          camera_no = i;
          break;
        }
      }
    }
    this.selectedDevice = this.scannerElment.getDeviceById(this.availableDevices[camera_no]['deviceId']);
  }

  unSetDevice() {
    this.selectedDevice = null;
  }

  handleQrCodeResult(resultString) {
    console.log('handleQrCodeResult', resultString);
    this.barcode_text = resultString;

    this.returnText.emit(this.barcode_text);
  }
}


// WEBPACK FOOTER //
// ./src/components/scanner/scanner.ts